export const membersCountSelector = state => state.members.count;
export const membersSelector = state => Object.values(state.members.list);
export const memberSelector = state => state.members.member;
